import { css } from "@emotion/react";

import { responsiveBreakpoint } from "@constants";

export const rowPolicies = css`
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 24px;

  @media (min-width: ${responsiveBreakpoint[0]}px) {
    height: 44px;
    margin-bottom: 0;
  }
`;

export const termsOfServiceDisclaimer = css`
  font-size: 14px;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: -0.2px;
  cursor: pointer;
  color: var(--gray-600);
`;

export const links = css`
  margin-right: 16px;
  font-weight: 400;
  font-size: 14px;
  line-height: 28px;
  letter-spacing: -0.2px;
  color: var(--gray-600);
  cursor: pointer;

  &:nth-of-type(2) {
    font-weight: 700;
  }
`;
